import _ from 'lodash';

let client = null;
const apiKey = '1c9de5b471e2aa3aeda6458fe67c360fab7e3ddc';
const username = 'raoulw';

export default {
	clearClient() {
		client = null;
	},
	getClient(clear) {
		if (clear)
			this.clearClient();
		const carto = window.carto;
		if (!carto) return;
		if (!client)
			client = this.newClient();
		return client;
	},
	newClient() {
		const carto = window.carto;
		return new carto.Client({ apiKey, username });
	},
	apiKey,
	username,
	getRegionsFilter(regions) {
		if (!regions) return '';
		const where = [];
		const countries = _.groupBy(regions, 'country.long_name');
		if (__DEBUG__)
			console.info('Countries: ', {countries, regions: regions.filter(f => !f.radius || f.radius && !f.isManuallyAdded)});

		for(var country in countries) {
			var states = _.groupBy(countries[country], 'state.long_name');
			if (__DEBUG__)
				console.info('States: ', {country, states});

			for (var state in states) {
				var cities = _.groupBy(countries[country], 'city.long_name');
				if (__DEBUG__)
					console.info('Cities: ', {country, state, cities});

				for(var city in cities) {
					const condition = [];

					var radiuses = cities[city].filter(f => f.radius > 0 && !f.searchNearbyPlaces);
					if (radiuses.length) {
						const radiusesCondition = [];
						radiuses.map(f => {
							radiusesCondition.push(`
								ST_intersects(
									the_geom,
									ST_Buffer(ST_SetSRID(ST_Point(${f.location.lng},${f.location.lat}),4326)::geography, ${f.radius})::geometry
								)`);
						});
						condition.push(`(${radiusesCondition.join(' OR ')})`);
					} else {
						if (state !== 'undefined')
							condition.push(`a_state = '${state}'`);
						if (city !== 'undefined')
							condition.push(`(a_city = '${city}' OR a_city like '${city};%' OR a_city like '%; ${city};%' OR a_city like '%; ${city}')`);
					}

					if (condition.length) {
						where.push(`(${condition.join(' AND ')})`);
					}
				}
			}
		}

		if (!where.length)
			where.push('(a_state = \'NOT_SPECIFIED\')');

		return where.join(' OR ');
	},
	buildQuery(regions, additionalFields, invert, opts) {
		if (__DEBUG__)
			console.log('Build query', {regions, additionalFields, invert, opts});

		const options = opts || {};
		const regionsWhere = options.regionsWhere || this.getRegionsFilter(regions);

		var where = [regionsWhere];
		if (options.filters) {
			where.push(options.filters);
		}
		var whereText = options.where || `${where.length ? 'WHERE' : ''} ${invert ? 'not' : ''} (${where.join('AND')})`;

		var query = `SELECT
			cartodb_id,
			the_geom,
			the_geom_webmercator,
			zcta5ce10,
			affgeoid10,
			geoid10,
			a_pop_num,
			a_per_ma_1,
			a_med_in_1
			${additionalFields ? `, ${additionalFields}` : ''}
		FROM alluszipswithdata ${whereText}`;

		if (__DEBUG__)
			console.info('Query: ', { query, opts });

		return query;
	},
	isMetricSystem() {
		var language = window.navigator.userLanguage || window.navigator.language;
		return !language || (language.toLowerCase().indexOf('us') === -1 && language.toLowerCase().indexOf('gb') === -1);
	},
	kmOrMiles() {
		return this.isMetricSystem() ? 'km' : 'miles';
	},
	metricMultiplier() {
		return this.isMetricSystem() ? 1000 : 1609.344;
	},
	stringToDecimalField(f) {
		return `REPLACE(REPLACE(${f},',',''),'$','')::decimal as ${f}`;
	},
	getMetricMultipliedValue(v) {
		return Math.round(v * this.metricMultiplier() * 100)/100;
	},
	getRadiusDividedValue(v) {
		return Math.round(v / this.metricMultiplier() * 100)/100;
	}
};
